import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const DeleteIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.33203 5.14706H16.6654M8.33203 13.9706V8.67647M11.6654 13.9706V8.67647M13.332 17.5H6.66536C5.74489 17.5 4.9987 16.7099 4.9987 15.7353V6.02941C4.9987 5.5421 5.37179 5.14706 5.83203 5.14706H14.1654C14.6256 5.14706 14.9987 5.5421 14.9987 6.02941V15.7353C14.9987 16.7099 14.2525 17.5 13.332 17.5ZM8.33203 5.14706H11.6654C12.1256 5.14706 12.4987 4.75202 12.4987 4.26471V3.38235C12.4987 2.89504 12.1256 2.5 11.6654 2.5H8.33203C7.87179 2.5 7.4987 2.89504 7.4987 3.38235V4.26471C7.4987 4.75202 7.87179 5.14706 8.33203 5.14706Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

DeleteIcon.displayName = 'DeleteIcon';
